/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import { X, CreditCard } from "lucide-react";
import { formatCurrency } from "../../utils/constants";

const UpdatePaymentModal = ({
  selectedPayment,
  showUpdateModal,
  setShowUpdateModal,
  handleFullPayment,
  handlePartialPayment,
  partialAmount,
  setPartialAmount,
  error,
  setError,
}) => {
  if (!showUpdateModal || !selectedPayment || selectedPayment.payingStatus === "paid") {
    return null;
  }

  const dueDate = new Date(selectedPayment.dueDate);
  const today = new Date();
  const isOverdue = selectedPayment.payingStatus !== "paid" && today > dueDate;
  
  const amountToPay = Number(selectedPayment.amountToPay || 0);
  const totalPaid = Number(selectedPayment.totalPaid || 0);
  
  let penaltyAmount = Number(selectedPayment.penaltyAmount || 0);
  if (isOverdue && penaltyAmount === 0 && !selectedPayment.penaltyWaived) {
    penaltyAmount = (amountToPay - totalPaid) * 0.2;
  }
  
  const totalAmountDue = amountToPay + penaltyAmount;
  const remainingBalance = Math.max(0, totalAmountDue - totalPaid);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-card dark:bg-dark-surface rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        <div className="p-6 border-b border-gray-100 dark:border-dark-border flex justify-between items-center">
          <h3 className="text-lg font-bold text-text dark:text-dark-text flex items-center gap-2">
            <CreditCard size={18} /> Update Payment
          </h3>
          <button onClick={() => setShowUpdateModal(false)}>
            <X size={20} className="text-gray-400 dark:text-dark-muted" />
          </button>
        </div>
        <div className="p-6">
          <div className="space-y-4">
            <div>
              <p className="text-sm text-gray-500 dark:text-dark-muted mb-1">
                Client
              </p>
              <p className="font-medium text-text dark:text-dark-text">
                {selectedPayment.name}
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-500 dark:text-dark-muted mb-1">
                Total Amount Due
              </p>
              <p className="font-medium text-text dark:text-dark-text">
                {formatCurrency(amountToPay)}
              </p>
              {penaltyAmount > 0 &&
                !selectedPayment.penaltyWaived && (
                  <p className="text-sm text-orange-500">
                    +{formatCurrency(penaltyAmount)} penalty
                  </p>
                )}
            </div>
            <div>
              <p className="text-sm text-gray-500 dark:text-dark-muted mb-1">
                Amount Paid
              </p>
              <p className="font-medium text-text dark:text-dark-text">
                {formatCurrency(totalPaid)}
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-500 dark:text-dark-muted mb-1">
                Remaining Balance
              </p>
              <p className="font-medium text-text dark:text-dark-text">
                {formatCurrency(remainingBalance)}
              </p>
            </div>

              <button
                onClick={handleFullPayment}
                className="w-full py-3 bg-green-500 hover:bg-green-600 text-white rounded-xl font-bold transition-colors"
              >
                Complete Full Payment
              </button>

              <div>
                <input
                  type="number"
                  placeholder="Enter partial payment amount"
                  className="w-full px-4 py-2 rounded-xl bg-accent dark:bg-gray-900 border border-gray-200 dark:border-dark-border text-sm focus:outline-none focus:ring-2 focus:ring-primary text-text dark:text-dark-text"
                  value={partialAmount}
                  onChange={(e) => {
                    setPartialAmount(e.target.value);
                    setError("");
                  }}
                />
                {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
              </div>

              <button
                onClick={handlePartialPayment}
                className="w-full py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-xl font-bold transition-colors"
              >
                Update Partial Payment
              </button>
            </div>
          </div>
        </div>
      </div>
    );
};

export default UpdatePaymentModal;
